import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Container, Row, Col } from 'reactstrap';

import {
  usePage,
  useTealium,
  useAdGlare,
  useUnmountResetPage,
  useNotFound,
  useDebounceLoading,
  useDelayJsLoadiing,
  useURLChangeCallback,
} from '../../utils/hookHelper';

import { sanitizedHTML, isSSOLoggedIn, forceToArray } from '../../utils/Helper';

import HelmetMeta from '../../components/HelmetMeta';
import HelmetTitle from '../../components/HelmetTitle';
import HelmetStyle from '../../components/HelmetStyle';
import HelmetScript from '../../components/HelmetScript';
import HelmetHead from '../../components/HelmetHead';
import Loader from '../../components/Loader';
import UnderConstruction from '../../components/UnderConstruction';
import PageIntro from '../../components/PageIntro';
import NoMatch from '../NoMatch';
import MemberOnly from '../../components/MemberOnly';
import VideoPlayer from '../../components/VideoPlayer';
import config from '../../config';
import { getStoryItems } from '../../redux/modules/storyItems/action';
import { getStoryItemByFilename } from '../../redux/modules/homepageStoryItems/action';
import { getStoryMainPage } from '../../redux/modules/moreStoriesItems/action';
import store from '../../redux/store';
import StoryContent from '../../components/StoryContent/StoryContent';
import {
  getMoreStoryItems,
  getRandomStoryItems,
  resetMoreStoryItems
} from '../../redux/modules/moreStoriesItems/action';
import swiper from 'swiper';
import { isEmpty } from 'lodash';

const ImageSlider = (props) => {
  const { images } = props;

  useEffect(() => {
    new swiper('#story-image-slider', {
      centeredSlides: true,
      spaceBetween: 36,
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
        renderBullet: (index, className) => {
          return index < 9
            ? `<span class="${className}">0${index + 1}</span>`
            : `<span class="${className}">${index + 1}</span>`;
        },
      },
    });
  }, []);

  return (
    <div className="image-slider-container">
      <div className="image-slider">
        <div className="swiper-container" id="story-image-slider">
          <div className="swiper-wrapper">
            {images.map((image, index) => {
              const imageCaption = image.storyImageCaption;
              const imageCaptionDiv = imageCaption && (
                <div
                  className="caption"
                  dangerouslySetInnerHTML={{ __html: sanitizedHTML(imageCaption) }}
                />
              );
              return (
                <div className="swiper-slide" key={index}>
                  <div className="image-slider-content">
                    <a
                      href={image.storyImageSrc}
                      data-type={'image'}
                      data-fancybox={'displayItem'}
                      data-caption={imageCaption}
                    >
                      <img src={image.storyImageSrc} alt={image.storyImageAlt} />
                    </a>
                    {imageCaptionDiv}
                  </div>
                </div>
              );
            })}
          </div>
          <div className="paginationDiv">
            <div className="swiper-pagination"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

const VideoSection = (props) => {
  const { video } = props;
  const { videoCover_upload, videoURL } = video;
  const [autoPlay, setAutoPlay] = useState(false);

  useEffect(() => {
    if (window.Fancybox) {
      window.Fancybox.bind('[data-fancybox="video-storyItem"]', {
        on: {
          destroy: () => setAutoPlay(false),
        },
      });
      window.Fancybox.bind('[data-fancybox="displayItem"]', {
        autoFocus: false,
        placeFocusBack: false,
        trapFocus: false,
      });
    }
  }, [window.Fancybox]);

  return (
    <>
      <a
        data-src={'#story-video-player'}
        data-fancybox={'video-storyItem'}
        className="story-video-player-trigger"
        onClick={() => setAutoPlay(true)}
      >
        <img src={videoCover_upload} />
      </a>
      <div style={{ display: 'none' }}>
        <VideoPlayer autoPlay={autoPlay} src={videoURL} id="story-video-player" />
      </div>
    </>
  );
};

const StoryDetailPage = (props) => {
  const {
    match = {},
    i18n,
    storyDetailPage,
    allowCookies,
    enableTealium,
    enableAdGlare,
    siteConfig,
    storyItems,
    moreStoryItems,
  } = props;
  const debouncePageLoading = useDebounceLoading(storyDetailPage);
  const jsLoading = useDelayJsLoadiing(storyDetailPage);
  const notFound = useNotFound(storyDetailPage);

  usePage(match.params.pageName, config.pageType.storyDetailPage);
  useAdGlare(i18n.locale, siteConfig, storyDetailPage, enableAdGlare.status);
  useUnmountResetPage();

  const { locale, translations } = i18n;
  const { storyDetailsPage } = translations[locale] || {};
  const { data = {} } = storyDetailPage || {};
  const content = ((data || {}).content || {}).content || {};
  const dataContent = content[locale] || {};
  const { under_construction = false } = content;
  const pageName = match.params.pageName;
  const pageNameForQuery = pageName.toLowerCase();
  const moreStoriesContent = moreStoryItems || {};
  const moreStoriesArray = moreStoriesContent[locale] || [];
  // content
  const headline = dataContent.headline || '';
  const description = dataContent.description || '';
  const storyAbstractImage = dataContent.storyAbstractImage || '';
  const storyAbstractAlt = dataContent.storyAbstractAlt || '';
  const storyAbstractCaption = dataContent.storyAbstractCaption || '';
  const contentBody = dataContent.content_body || '';
  const contentFooter = dataContent.content_bottom || '';
  /* const thumbnail = dataContent.thumbnail || ''; */

  const video = dataContent.video || {};
  const storyImages = dataContent.storyImages?.storyImage || [];
  const storyImagesArray = forceToArray(storyImages);
  // const videoContainer = dataContent.video || {};
  // const videoType = videoContainer.videoType;
  // const videoURL = videoContainer.videoURL;
  // const videoCover = videoContainer.videoCover_upload;

  // HelmetMeta
  const { metadata = {} } = data || {};
  const publishDate = metadata['TeamSite/LiveSite/PublishDate'];
  const seo = dataContent.seo || {};
  const { css_style_block = '', js_script_block = '', extra_head = '' } = content;

  const title = seo.seo_title;
  const [domTitle, setDomTitle] = useState('');
  const [isScriptReady, setIsScriptReady] = useState(false);
  const [storyItem, setstoryItem] = useState({});
  const [storyItemLocale, setstoryItemLocale] = useState({});
  const [mainPage, setMainPage] = useState({});
  const mainPageContent = mainPage[locale] || {};
  const storyDetails = mainPageContent.storyDetails || {};
  const storyID = storyItemLocale ? storyItemLocale.storyID : '';
  const storyDetailsTitle = storyDetails ? storyDetails.title : '';
  const storyDetailsUrl = storyDetails ? storyDetails.bgPic : '';

  const item = {
    section4_title: storyDetailsTitle,
    section4_color: storyDetailsUrl,
  };

  useTealium(
    i18n.locale,
    siteConfig,
    storyDetailPage,
    allowCookies.status,
    enableTealium.status,
    domTitle,
  );

  useURLChangeCallback(locale, data, null, [], isScriptReady);

  const helmetTitleCallBack = (newState) => {
    setDomTitle(newState.title);
  };

  const helmetScriptCallBack = (isReady) => {
    setIsScriptReady(isReady);
  };

  useEffect(() => {
    if (pageNameForQuery) {
      getStoryItemByFilename(pageNameForQuery).then((result) => {
        setstoryItem(result);
      });
    }
  }, [pageNameForQuery]);

  useEffect(() => {
    if (!isEmpty(storyItem)) {
      setstoryItemLocale(storyItem[locale][0]);
    }
  }, [storyItem, locale]);

  useEffect(() => {
    if (!isEmpty(storyID)) {
      getRandomStoryItems(storyID).then((result) => {
        const [item1, item2, item3, item4, item5, item6] = result;
        store.dispatch(getMoreStoryItems(item1, item2, item3, item4, item5, item6));
      });
    }
  }, [match.params.pageName, storyID]);

  useEffect(() => {
    getStoryMainPage('main', 'Designer Story/Main Page').then((result) => {
      const content = result.content.content;
      setMainPage(content);
    });
  }, []);

  useEffect(() => {
    return () => {
      store.dispatch(resetMoreStoryItems())
    }
  }, [])

  const headlineEle = <>{headline && <PageIntro headline={headline} />}</>;

  const headlineDesc = description && (
    <h3 dangerouslySetInnerHTML={{ __html: sanitizedHTML(description) }} />
  );

  const mainContent = contentBody && (
    <div
      className="main-content"
      dangerouslySetInnerHTML={{ __html: sanitizedHTML(contentBody) }}
    />
  );

  const bottomContent = contentFooter && (
    <div dangerouslySetInnerHTML={{ __html: sanitizedHTML(contentFooter) }} />
  );

  // make sure SSO is ready
  const memberOnlyInd = metadata.memberOnly === 'true';

  // const VideoSection = () => {
  //   return (
  //     (videoURL && (
  //       <div className="row">
  //         <div className="col-sm-12 col-md-12 col-lg-6 col-xl-4">
  //           <VideoPlayer src={videoURL} thumbnail={videoCover} />
  //           {`videoType: ${videoType} `} <br />
  //           {`videoURL: ${videoURL}`} <br />
  //           {`videoCover: ${videoCover}`} <br /> <br />
  //         </div>
  //       </div>
  //     )) || <></>
  //   );
  // };

  const Thumbnail = ({}) => {
    return (
      <Col className="thumbnailCol">
        <div className="thumbnailColDiv">
          {storyItemLocale && (
            <div
              className="thumbnailColDivImg"
              style={{ backgroundImage: `url(${storyItemLocale.cover})` }}
            />
          )}
          <div className="thumbnailColh1Div">
            <h2>{storyDetailsPage.designer}</h2>
            <div>
              <h2>{storyDetailsPage.story}</h2>
            </div>
          </div>
        </div>
      </Col>
    );
  };

  const HeadlineDescContent = ({}) => {
    return (
      <div className="descContentRow">
        <div className="column-left">
          <div>
            {storyItemLocale && (
              <h5 className="descContentRowh5">{storyItemLocale.mainCategory_name}</h5>
            )}
            <h1 className="descContentRowh1">{headline}</h1>
            {storyItemLocale && <h4 className="descContentRowh4">{storyItemLocale.company}</h4>}
          </div>
        </div>
        <div className="column-right">
          {headlineDesc}
          {storyAbstractImage && storyAbstractCaption && (
            <>
              <div className="abstract-image">
                <img src={storyAbstractImage} alt={storyAbstractAlt} />
              </div>
              <div
                  className="abstract-caption"
                  dangerouslySetInnerHTML={{ __html: sanitizedHTML(storyAbstractCaption) }}
                />
            </>
          )}
          {video && <VideoSection video={video} />}
        </div>
      </div>
    );
  };

  useEffect(() => {
    if (match.params.category != undefined) {
      store.dispatch(getStoryItems(match.params.category));
    }
  }, [match.params.category]);

  const contentEle =
    memberOnlyInd && !isSSOLoggedIn() ? (
      <MemberOnly />
    ) : (
      <>
        <Container>
          {under_construction && <UnderConstruction />}
          {/* {!under_construction && <Thumbnail />}
            {!under_construction && <HeadlineDescContent />}
            {!under_construction && mainContent}
            {!under_construction && <VideoSection />}
          {!under_construction && bottomContent} */}
          {!under_construction && (
            <>
              <div className="globalWidth maxWidthContainer">
                <Thumbnail />
                <HeadlineDescContent />
                {/* <VideoSection /> */}
                {!isEmpty(storyImagesArray) && storyImagesArray.length > 0 && (
                  <ImageSlider images={storyImagesArray} />
                )}
                {mainContent}

                {bottomContent}
              </div>
              <StoryContent data={item} storyArray={moreStoriesArray} page="details" locale={locale}/>
              <HelmetScript
                helmetScriptCallBack={helmetScriptCallBack}
                extraHead={extra_head}
                jsScript={js_script_block}
              />
            </>
          )}
        </Container>
      </>
    );

  const pageEle = (
    <div>
      {notFound ? (
        <NoMatch />
      ) : (
        <div className="storyDetailPage">
          {/* {headlineEle} */}
          {contentEle}
        </div>
      )}
    </div>
  );

  return (
    <>
      {debouncePageLoading || jsLoading ? <Loader /> : pageEle}
      {!debouncePageLoading && <HelmetHead extraHead={extra_head} />}
      {!debouncePageLoading && <HelmetStyle stylesheet={css_style_block} />}
      {!debouncePageLoading && <HelmetTitle title={title} cb={helmetTitleCallBack} />}
      {!debouncePageLoading && <HelmetMeta seo={seo} publishDate={publishDate} />}
    </>
  );
};

const mapStateToProps = (state) => ({
  i18n: state.i18n,
  storyDetailPage: state.generalPage,
  allowCookies: state.allowCookies,
  enableTealium: state.enableTealium,
  enableAdGlare: state.enableAdGlare,
  siteConfig: state.siteConfig,
  storyItems: state.storyItems.data,
  moreStoryItems: state.moreStoriesItems.data,
});

const connectStore = connect(mapStateToProps, null, null, {
  pure: true,
})(StoryDetailPage);

export { StoryDetailPage as StoryDetailPageComponent }; // <- For component Unit Test
export default connectStore;
